import Axios from 'axios'

export default {
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        deleteExperience: async ({ commit, getters }, payload) => {
            commit('setLoading')
            await Axios.delete(`${process.env.VUE_APP_API_URL_EXPERIENCE}${payload}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                })
                .then(res => {
                    if (res.request.status != 200)
                        res.data = []
                    let newExperiences = getters.user.coach.experience.filter(el => {
                        return el._id != payload;
                    });
                    commit('addExperience', JSON.parse(JSON.stringify(newExperiences)))
                    commit('setUser', getters.user);
                    localStorage.setItem('currentUser', JSON.stringify(getters.user))
                    commit('setLoading')
                }
                ).catch(error => {
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                })
        },
        async updateCoachInfo({ commit, getters }) {
            console.log('updateCoachInfo', getters.user.coach)
            commit('setLoading')
            await Axios.put(
                `${process.env.VUE_APP_API_URL_COACHS_ROUTE}${getters.user.coach._id}`, getters.user.coach)
                .then(res => {
                    commit('clearSnackAlert')
                    commit('setSnackAlert', {
                        status: true,
                        success: true,
                        error: false,
                        message: 'Vos packs sont enregistré.'
                    })
                    commit('setLoading')
                }
                ).catch(error => {
                    commit('clearSnackAlert')
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: '<strong>Erreur:</strong> ' + error.message
                    })
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                })
        }
    }
}
